import { Component, type ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

/** Keeps a render error inside the Fulfilment Index tab, so one tab can never blank the portal shell (bug 3fd0402f-8183). */
export class FulfilmentIndexBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <Alert variant="destructive"><AlertDescription>The Fulfilment Index could not be shown for this selection. <Button data-nonmutating variant="outline" size="sm" onClick={() => this.setState({ failed: false })}>Try again</Button></AlertDescription></Alert>;
  }
}
